<div class="col1">
  <div class="header">
    <h1>{{ statsTitle }}</h1>
  </div>

  @if (stats$ | async; as stats) {
    <div class="board">
      <div class="labels">
        <div class="queueName"></div>
        @for (stat of stats.data; track stat) {
          <div>{{ stat.queueName || 'Unknown queue' }}</div>
        }
        <div>TOTAL CALL QUEUES</div>
      </div>
      <div class="queue">
        <div class="queueName">Total Inbound</div>
        @for (stat of stats.data; track stat) {
          <div>{{ stat?.totalCalls || 0 }}</div>
        }
        <div>{{ stats.dataSummary?.totalCalls }}</div>
      </div>
      <div class="queue">
        <div class="queueName">Total Callbacks</div>
        @for (stat of stats.data; track stat) {
          <div>{{ stat?.callbacksHandled || 0 }}</div>
        }
        <div>{{ stats.dataSummary?.callbacksHandled }}</div>
      </div>
      <div class="queue">
        <div class="queueName">Handled / Abandoned</div>
        @for (stat of stats.data; track stat) {
          <div>{{ stat?.contactsHandled || 0 }} / {{ stat?.contactsAbandoned || 0 }}</div>
        }
        <div>{{ stats.dataSummary?.contactsHandled }} / {{ stats.dataSummary?.contactsAbandoned }}</div>
      </div>
      <div class="queue">
        <div class="queueName">Calls Waiting</div>
        @for (stat of stats.data; track stat) {
          <div>{{ stat?.callsWaiting || 0 }}</div>
        }
        <div [ngClass]="{ alert: stats.dataSummary?.callsWaitingOverThreshold }">{{ stats.dataSummary?.callsWaiting }}</div>
      </div>
      <div class="queue">
        <div class="queueName">ASA</div>
        @for (stat of stats.data; track stat) {
          <div>{{ stat?.ASA || 0 }}</div>
        }
        <div>{{ stats.dataSummary?.ASA }}</div>
      </div>
      <div class="queue">
        <div class="queueName">Longest Wait Time</div>
        @for (stat of stats.data; track stat) {
          <div [ngClass]="{ alert: stat?.oldestContactOverThreshold }">
            {{ stat?.oldestContact }}
          </div>
        }
        <div>{{ stats.dataSummary?.oldestContact }}</div>
      </div>
    </div>
  }
  <app-status-summary [available]="available" [notAvailable]="notAvailable" [outOfOffice]="outOfOffice"></app-status-summary>
</div>
<div class="col2">
  <ion-slides pager="false" [options]="slideOpts" class="wallboard-slides">
    <ion-slide>
      <div class="page">
        @for (statusGroup of agentsPage1$ | async; track statusGroup) {
          <app-card-frame [title]="statusGroup[0]?.CurrentEvent.Status.Item.GroupName" class="frame">
            @for (agent of statusGroup; track agent) {
              <app-agent-card [agent]="agent"></app-agent-card>
            }
          </app-card-frame>
        }
      </div>
    </ion-slide>
    @if ((agentsPage2$ | async)?.length > 0) {
      <ion-slide>
        <div class="page">
          @for (statusGroup of agentsPage2$ | async; track statusGroup) {
            <app-card-frame [title]="statusGroup[0]?.CurrentEvent.Status.Item.GroupName" class="frame">
              @for (agent of statusGroup; track agent) {
                <app-agent-card [agent]="agent"></app-agent-card>
              }
            </app-card-frame>
          }
        </div>
      </ion-slide>
    }
    @if ((agentsPage3$ | async)?.length > 0) {
      <ion-slide>
        <div class="page">
          @for (statusGroup of agentsPage3$ | async; track statusGroup) {
            <app-card-frame [title]="statusGroup[0]?.CurrentEvent.Status.Item.GroupName" class="frame">
              @for (agent of statusGroup; track agent) {
                <app-agent-card [agent]="agent"></app-agent-card>
              }
            </app-card-frame>
          }
        </div>
      </ion-slide>
    }
    <div class="header">
      <h1>{{ agentsTitle }}</h1>
    </div>
    @if ((agentsPage4$ | async)?.length > 0) {
      <ion-slide>
        <div class="page">
          @for (statusGroup of agentsPage4$ | async; track statusGroup) {
            <app-card-frame [title]="statusGroup[0]?.CurrentEvent.Status.Item.GroupName" class="frame">
              @for (agent of statusGroup; track agent) {
                <app-agent-card [agent]="agent"></app-agent-card>
              }
            </app-card-frame>
          }
        </div>
      </ion-slide>
    }
  </ion-slides>
</div>
